export default __webpack_public_path__ + "static/media/step-2-ar.791bd16e.png";